const Mobile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="22"
      viewBox="0 0 14 22"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#4F4335" fillRule="nonzero">
          <g>
            <g>
              <g>
                <path
                  d="M11.5 0h-9C1.12 0 0 1.12 0 2.5v17C0 20.88 1.12 22 2.5 22h9c1.38 0 2.5-1.12 2.5-2.5v-17C14 1.12 12.88 0 11.5 0zM7 20.125c-.622 0-1.125-.503-1.125-1.125S6.378 17.875 7 17.875s1.125.503 1.125 1.125S7.622 20.125 7 20.125zM12 17H2V3h10v14z"
                  transform="translate(-736 -553) translate(165 294) translate(534 123) translate(37 136)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export { Mobile };
